module.exports = __webpack_public_path__ + "img/kpfui_logo.17df966a.png";